import styles from './SvgContainer5.module.css';

const SvgContainer5 = () => {
  return (
    <div className={styles.svgContainer}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1512"
        height="1200"
        viewBox="0 100 1512 900"
        fill="none"
        className={styles.blackSvg}
      >
        <path d="M-52 0H1553V1300H-52V0Z" fill="#1D1534" />
      </svg>
    </div>
  )
};

export default SvgContainer5;